/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ServiceDrivenFieldViewer} from "../../../Models/Core/FieldViewers/ServiceDrivenFieldViewer";
import {service as SpeciesService} from "../../../Services/SpeciesService";


export const SpeciesFieldViewer = ServiceDrivenFieldViewer(SpeciesService);